/*
 * Wishlist storage layer (Saved feature)
 * Single source of truth in localStorage. Stores an array of
 * { id, url } objects. Backward-compatible: legacy entries saved as
 * bare ID strings are still read correctly (url defaults to '').
 * Fires a `wishlist:changed` CustomEvent on document for UI to react.
 */
(function () {
  'use strict';

  var STORAGE_KEY = 'soosmarts:wishlist';

  function readRaw() {
    try {
      var raw = window.localStorage.getItem(STORAGE_KEY);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed)) return [];
      // Normalize each entry to { id, url }. Legacy entries are bare
      // strings/numbers; new entries are objects.
      return parsed.map(function (entry) {
        if (entry && typeof entry === 'object') {
          return { id: String(entry.id), url: entry.url ? String(entry.url) : '' };
        }
        return { id: String(entry), url: '' };
      }).filter(function (e) { return e.id && e.id !== 'undefined'; });
    } catch (e) {
      return [];
    }
  }

  function writeRaw(items) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
      return true;
    } catch (e) {
      return false;
    }
  }

  function norm(id) {
    return String(id);
  }

  // Full item objects: [{ id, url }]
  function getItems() {
    return readRaw();
  }

  // Just the IDs (kept for existing heart-sync code).
  function getAll() {
    return readRaw().map(function (e) { return e.id; });
  }

  function has(id) {
    return getAll().indexOf(norm(id)) !== -1;
  }

  function count() {
    return readRaw().length;
  }

  function emit() {
    document.dispatchEvent(
      new CustomEvent('wishlist:changed', {
        detail: { ids: getAll(), items: getItems(), count: count() }
      })
    );
  }

  function add(id, url) {
    var items = readRaw();
    var key = norm(id);
    for (var i = 0; i < items.length; i++) {
      if (items[i].id === key) {
        // Already present; backfill url if we now have one.
        if (url && !items[i].url) { items[i].url = String(url); writeRaw(items); }
        return true;
      }
    }
    items.push({ id: key, url: url ? String(url) : '' });
    writeRaw(items);
    emit();
    return true;
  }

  function remove(id) {
    var items = readRaw();
    var key = norm(id);
    var next = items.filter(function (e) { return e.id !== key; });
    if (next.length !== items.length) {
      writeRaw(next);
      emit();
    }
    return false;
  }

  function toggle(id, url) {
    return has(id) ? remove(id) : add(id, url);
  }

  window.addEventListener('storage', function (e) {
    if (e.key === STORAGE_KEY) emit();
  });

  window.Wishlist = {
    add: add,
    remove: remove,
    toggle: toggle,
    has: has,
    getAll: getAll,
    getItems: getItems,
    count: count,
    STORAGE_KEY: STORAGE_KEY
  };

  // --- Global wishlist badge painter ---
  // Lives here because wishlist.js loads on EVERY page (theme.liquid defer),
  // unlike mobile-tab-bar.liquid which does NOT render on product pages —
  // that's why the header badge was stuck hidden at 0 on PDPs.
  function paintWishlistBadges() {
    var badges = document.querySelectorAll('[data-wishlist-badge]');
    if (!badges.length) return;
    var n = count();
    badges.forEach(function (badge) {
      badge.textContent = n;
      badge.hidden = n < 1;
    });
  }
  document.addEventListener('wishlist:changed', paintWishlistBadges);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintWishlistBadges);
  } else {
    paintWishlistBadges();
  }
})();
